import React, { useContext, useState } from "react";
import { saveAs } from "file-saver";
import { CustomToast } from "../../../shared/components/alert/custom-toast";
// import { CustomLoader } from "../../../shared/components/custom-loader/custom-loader";
import { HELPER } from "../../../shared/helper/helper";
import moment from "moment";
import { SHARED_SERVICES } from "../../../core/services/shared-services";
import { Optional } from "../optional/optional";
import { DownloadProgress } from "../download-progress/download-progress";
import { MainContext } from "../../../../App";

export function DownloadConfirmation(props) {
  const [loading, setLoading] = useState(false);
  const [downloadError, setDownloadError] = useState(null);
  const mainContext = useContext(MainContext);

  function downloadReport() {
    setLoading(true);
    let date = props?.report?.createdAt;
    if (date && date?.length === 7) {
      date.pop();
    }
    date = moment(date, "YYYY MM DD HH mm ss").format("YYYY-MM-DD");
    SHARED_SERVICES.DOWNLOAD_TRANSACTION_REPORT(
      props?.report?.recordId,
      props.type,
      mainContext
    )
      .then((data) => {
        saveAs(
          data,
          `${props?.report?.owner}-report_generated_at-${date}.xlsx`
        );
        props.closeModal();
      })
      .catch((error) => {
        handleError(error);
      });
  }

  async function handleError(error) {
    const errMessage = await HELPER.PARSE_BLOB_ERROR(error);
    setDownloadError(errMessage);
    setLoading(false);
  }

  return (
    <div>
      <h4 className="p-text-left p-mt-0">Confirm Download!</h4>
      <p className="p-text-left">
        Confirm that you want to download this report.
      </p>
      <div className="p-pb-1">
        {downloadError && (
          <CustomToast title="Error" description={downloadError} type="error" />
        )}
      </div>
      <Optional show={loading}>
        <DownloadProgress />
      </Optional>
      <Optional show={!loading}>
        <div className="p-mt-4 p-pb-2">
          <div className="p-grid">
            <div className="p-col-6">
              <button onClick={props.closeModal} className="secondary-button">
                Cancel
              </button>
            </div>
            <div className="p-col-6">
              <button onClick={downloadReport} className="primary-button">
                Download
              </button>
            </div>
          </div>
        </div>
      </Optional>
    </div>
  );
}
